const headRowsTableMaintenances = {
  id: 'ID',
  equipment: 'Equipamento',
  createdAt: 'Criada em',
  sendToMaintenanceDate: 'Data de Envio',
  returnFromMaintenanceDate: 'Data de Retorno',
  warrantyDate: 'Prazo de Garantia',
  expirationDate: 'Prazo de Validade',
  place: 'Local',
  amount: 'Valor',
  status: 'Status'
};

export default headRowsTableMaintenances;
